import { useEffect, useState } from 'react';
import { loadEventCategoryRenames } from '../services/events/eventCategoryRename';

/** Load the shared rename map once and return a revision so option lists rebuild. */
export function useEventCategoryRenames() {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let cancelled = false;
    loadEventCategoryRenames()
      .then((renames) => {
        if (cancelled) return;
        if (renames && Object.keys(renames).length > 0) {
          setRevision((current) => current + 1);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return revision;
}
